export default "__VITE_ASSET__3ca0042e__"